// extracted by mini-css-extract-plugin
export default {"td_end":"MonthReport_td_end__uFrja","td_start":"MonthReport_td_start__+o3Ll"};